export function jsonpRequest(url) {
  return new Promise(function (resolve, reject) {
    if (!document.head) {
      reject();
      return;
    }

    var hash = "_jsonpCallback_".concat(getRandomCallBackId());
    var script = document.createElement('script');
    script.async = true;
    script.src = url.indexOf('?') >= 0 ? "".concat(url, "&callback=").concat(hash) : "".concat(url, "?callback=").concat(hash);

    script.onerror = function (e) {
      reject(e);
    };

    window.addEventListener('error', handleWindowError); // Handle html responses, for example 302 redirect
    // eslint-disable-next-line @typescript-eslint/no-unused-vars

    function handleWindowError(_event) {
      window.removeEventListener('error', handleWindowError);
      reject();
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any


    window[hash] = function (data) {
      document.head.removeChild(script); // eslint-disable-next-line @typescript-eslint/no-explicit-any

      delete window[hash];
      window.removeEventListener('error', handleWindowError);
      resolve(data);
    };

    document.head.appendChild(script);
  });
}

function getRandomCallBackId() {
  return Math.random().toString(36).substr(2, 8);
}